import { render, staticRenderFns } from "./LoadMobile.vue?vue&type=template&id=47b4e6ae&scoped=true&"
import script from "./LoadMobile.vue?vue&type=script&lang=js&"
export * from "./LoadMobile.vue?vue&type=script&lang=js&"
import style0 from "./LoadMobile.vue?vue&type=style&index=0&id=47b4e6ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b4e6ae",
  null
  
)

export default component.exports